module.exports = __webpack_public_path__ + "img/not-found-impostor.017207b2.png";